import axiosInstance from '../api/axiosInstance';

/**
 * packingListService — All Packing List API calls
 *
 *  GET    /packing-list           → list all packing lists
 *  POST   /packing-list           → create a new packing list
 *  PUT    /packing-list/{id}      → update an existing packing list by ID
 *  DELETE /packing-list/{id}      → delete a packing list by ID
 */

// Fetch all packing lists
export const getPackingLists = (params) => {
  return axiosInstance.get('/packing-list', { params }).then((res) => res.data);
};

// Create a new packing list
export const savePackingList = (data) => {
  return axiosInstance.post('/packing-list', data).then((res) => res.data);
};

// Update an existing packing list
export const updatePackingList = (id, data) => {
  return axiosInstance.put(`/packing-list/${id}`, data).then((res) => res.data);
};

// Get a single packing list by ID
export const getPackingListById = (id) => {
  return axiosInstance.get(`/packing-list/${id}`).then((res) => res.data);
};

// Delete a packing list
export const deletePackingList = (id) => {
  return axiosInstance.delete(`/packing-list/${id}`).then((res) => res.data);
};

